<template>
  <div>
    <!-- 轮播图 -->
    <div class="header">
      <div class="header-tag">About us</div>
      <!-- <div class="header-title">关于我们</div> -->
    </div>
    <div style="margin: 30px 0;">
      <div class="w">
        <div class="flex1">
          <div class="left">
            <img src="@/assets/img/关于我们配图-01.jpg" alt="">
          </div>
          <div class="right">
            <div> 
              <div class="titles">Profile</div>
              <!-- <div class="sub-title">Profile</div> -->
            </div>
            <div class="content">
              <p>FJ Controlling Co., Ltd. is a national high-tech enterprise dedicated to the research&development, manufacture and sales
of products such as medium and low voltage-high current motor controllers, smart display, and rsmart terminals. FJ controlling is a
director unit of China Industrial Vehicle Industry Association, a specialized and innovative small and medium-sized enterprise in Jiangsu
Province, and the main drafting unit of China's first non-road electric controller standard.</p>
              <p>Since its establishment in 2011, the company has always focused on the research and development of electronic control compo-
nents, insisting on serving customers with independent core technology. The series of products independently developed and produced
include electric vehicle controller, smart display, remote monitoring and management systems, etc., which have been successfully
applied in the fields of electric forklifts, electric storage vehicles, electric sightseeing vehicles, golf carts, sanitation vehicles, aerial work
platforms, construction machinery, agriculture, gardening, and ships. Customers cover leading enterprises in the whole vehicle industry
such as Terex, Zoomlion, BYD Forklift, Heli Group, Lonking, XCMG Group, etc., providing one-stop solutions for electric control,
intelligence, and internet connection for off-road vehicle enterprises.</p>
            </div>
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <div>
              <div class="titles">Customer Value</div>
              <!-- <div class="sub-title">Customer Value</div> -->
            </div>
            <div class="content">
              <p>Rapid：Rapidly respond to customer demand</p>
              <!-- <p>Rapidly ：Quick response to customer requirements in numerous segmented fields</p> -->
              <p>Reliable：Safe and high-quality products, and efficient productions</p>
              <p>Advanced：Advanced technology and testing capabilities</p>
              <!-- <p>Advanced：Internationally leading technology and advanced testing capabilities</p> -->
              
              <!-- <p>Reliable：High quality products with efficient process of quality control</p> -->
            </div>
          </div>
          <div class="right">
            <img src="@/assets/img/关于我们配图-02.jpg" alt="">
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <img src="@/assets/img/关于我们配图-03.jpg" alt="">
          </div>
          <div class="right">
            <div>
              <div class="titles">Vision</div>
              <!-- <div class="sub-title">Vision</div> -->
            </div>
            <div class="content">
              <p>To be a world-class enterprise in off-road electric drive and to contribute to the promotion of global popularization of electrification.</p>
            </div>
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <div>
              <div class="titles">Shared Value</div>
              <!-- <div class="sub-title">Shared Value</div> -->
            </div>
            <div class="content">
              <p>Customer - Customer first, service first;</p>
              <p>Responsibility  - Take Charge, embrace Change;</p>
              <p>Integrity - Keep your word, deliver on your promises;</p>
              <p>Simple - Honest communication, efficient action.</p>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/img/关于我们配图-04.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
export default Vue.component('Timeline', {
  name: "Timeline",
  props: {
    timelineList: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
})
</script>

<style scoped lang="scss">
.header {
  background: url('../../assets/img/aboutusbanner.jpg') no-repeat;
  background-size: 100% ;
}

.flex1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 400px;
  margin-top: 30px;
}

.flex1 img {
  width: 100%;
  height: 400px;
}

.left {
  width: 48%;
}

.right {
  width: 48%;
}
.titles {
  font-size: 24px;
}
.sub-title {
  font-size: 20px;
  margin-top: 10px;
  color: #999;
}
.content {
  max-height: 400px;
  overflow: hidden;
}
.content p{
  margin-top: 10px;
  text-indent: 2rem;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue